import React, { useState } from "react";
import { Table, Button, Popconfirm, Form, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined, LinkOutlined } from "@ant-design/icons";
import ModalEvaluationLinks from "../modalEvaluationLinks/modalEvaluationLinks";

const TableEvaluations = ({ data, openForm, handleDelete }) => {
    const [form] = Form.useForm();
    const [showLinksModal, setShowLinksModal] = useState(false);
    const [selectedEvlId, setSelectedEvlId] = useState(null);

    const handleOpenLinksModal = (evl_id) => {
        setSelectedEvlId(evl_id);
        setShowLinksModal(true);
    };

    const handleCloseLinksModal = () => {
        setShowLinksModal(false);
        setSelectedEvlId(null);
    };

    const edit = (record) => {
        openForm(true, record.evl_id);
    };

    const columns = [
        {
            title: "Nombre evaluación",
            dataIndex: "evl_title",
            key: "evl_title",
        },
        {
            title: "Acciones",
            key: "actions",
            align: "center",
            render: (_, record) => (
                <>
                    <Tooltip title="Editar">
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => edit(record)}
                            style={{ marginRight: 8 }}
                        />
                    </Tooltip>

                    <Tooltip title="Ver enlaces">
                        <Button
                            icon={<LinkOutlined />}
                            onClick={() => handleOpenLinksModal(record.evl_id)}
                            style={{ marginRight: 8 }}
                        />
                    </Tooltip>

                    <Tooltip title="Eliminar">
                        <Popconfirm
                            title="¿Seguro que deseas eliminar esta evaluación?"
                            onConfirm={() => handleDelete(record.evl_id)}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Button danger icon={<DeleteOutlined />} />
                        </Popconfirm>
                    </Tooltip>
                </>
            )
        },
    ];

    return (
        <>
            <Form form={form} component={false}>
                <Table
                    className="custom-green-table"
                    size="small"
                    dataSource={data}
                    rowKey="evl_id"
                    columns={columns}
                    pagination={{ pageSize: 10, position: ["bottomRight"] }}
                    scroll={{ x: "max-content" }}
                />
            </Form>

            <ModalEvaluationLinks
                visible={showLinksModal}
                onClose={handleCloseLinksModal}
                evl_id={selectedEvlId}
            />
        </>
    );
};

export default TableEvaluations;
